import DailyBoxShow from './DailyBoxShow'
export {DailyBoxShow}
export default DailyBoxShow
